import React from 'react'

import { HeadingMedium, BodyText } from '@pb/components'

import PrimaryAction from 'ui/buttons/PrimaryAction'

import styles from './OrderError.scss'

export interface PrimitiveProps {
  headline: Object
  text: Object
}
export interface ComplexProps {
  button?: {
    type?: string
    text?: Object
    link?: string
    onClick?: Function
  }
}
export interface EventProps {}

export type OrderErrorProps = PrimitiveProps & ComplexProps & EventProps

const OrderError: React.FC<OrderErrorProps> = ({ headline, text, button = null }) => (
  <div className={styles.container}>
    <HeadingMedium center>{headline}</HeadingMedium>
    <BodyText center className={styles.text}>
      {text}
    </BodyText>
    {button && (
      <PrimaryAction
        size="large"
        tag={button.type}
        onClick={button.onClick}
        link={button.link}
        className={styles.button}
      >
        {button.text}
      </PrimaryAction>
    )}
  </div>
)

export default OrderError
